(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('InsuranceLevel', InsuranceLevel);

    InsuranceLevel.$inject = ['$resource'];

    function InsuranceLevel ($resource) {
        var resourceUrl =  'api/insurance-levels/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': { url: 'api/insurance-levels/by-corporation/:id', method: 'GET', isArray: true }
        });
    }
})();
